module.exports = __webpack_public_path__ + "static/media/ic_play_xl.0a8425b5.svg";